import React from 'react'

function PreviewMode({ className }) {
  return (
    <svg
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon--preview-mode${className ? ' ' + className : ''}`}
    >
      <path d="M6 6v36h36v-36h-36zm16 32h-12v-12h12v12zm0-16h-12v-12h12v12zm16 16h-12v-12h12v12zm0-16h-12v-12h12v12z" />
      <path d="M0 0h48v48h-48z" fill="none" />
    </svg>
  )
}

export default PreviewMode
